var _defs, _path, _path2, _rect, _path3, _rect2, _rect3, _path4, _rect4, _rect5, _path5, _path6, _path7, _path8, _polygon, _polygon2, _path9, _path10, _path11, _path12, _polygon3, _path13, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWithText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 566.93 536.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-2,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-3,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-4,.cls-40,.cls-41,.cls-42,.cls-43,.cls-44,.cls-45,.cls-46,.cls-47,.cls-48,.cls-49,.cls-5,.cls-50,.cls-51,.cls-52,.cls-53,.cls-54,.cls-55,.cls-56,.cls-57,.cls-58,.cls-59,.cls-6,.cls-60,.cls-61,.cls-62,.cls-63,.cls-64,.cls-65,.cls-66,.cls-67,.cls-68,.cls-69,.cls-7,.cls-70,.cls-71,.cls-72,.cls-73,.cls-74,.cls-75,.cls-76,.cls-77,.cls-78,.cls-79,.cls-8,.cls-80,.cls-81,.cls-82,.cls-83,.cls-84,.cls-85,.cls-86,.cls-87,.cls-88,.cls-89,.cls-9,.cls-90,.cls-91,.cls-92,.cls-93,.cls-94,.cls-95,.cls-96,.cls-97,.cls-98,.cls-99{fill:none;}.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-2,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-3,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-4,.cls-40,.cls-41,.cls-42,.cls-43,.cls-44,.cls-45,.cls-46,.cls-47,.cls-48,.cls-49,.cls-5,.cls-50,.cls-51,.cls-52,.cls-53,.cls-54,.cls-55,.cls-56,.cls-57,.cls-58,.cls-59,.cls-6,.cls-60,.cls-61,.cls-62,.cls-63,.cls-64,.cls-65,.cls-66,.cls-67,.cls-68,.cls-69,.cls-7,.cls-70,.cls-71,.cls-72,.cls-73,.cls-74,.cls-75,.cls-76,.cls-77,.cls-78,.cls-79,.cls-8,.cls-80,.cls-81,.cls-82,.cls-83,.cls-84,.cls-85,.cls-86,.cls-87,.cls-88,.cls-89,.cls-9,.cls-90,.cls-91,.cls-92,.cls-93,.cls-94,.cls-95,.cls-96,.cls-97,.cls-98,.cls-99{stroke:#fff;stroke-linecap:round;stroke-dasharray:0 14.6;}.cls-2{stroke-width:14.16px;}.cls-3{stroke-width:7.3px;}.cls-4{stroke-width:7.37px;}.cls-5{stroke-width:7.44px;}.cls-6{stroke-width:7.51px;}.cls-7{stroke-width:7.58px;}.cls-8{stroke-width:7.65px;}.cls-9{stroke-width:7.72px;}.cls-10{stroke-width:7.79px;}.cls-11{stroke-width:7.87px;}.cls-12{stroke-width:7.94px;}.cls-13{stroke-width:8.01px;}.cls-14{stroke-width:8.08px;}.cls-15{stroke-width:8.15px;}.cls-16{stroke-width:8.22px;}.cls-17{stroke-width:8.29px;}.cls-18{stroke-width:8.36px;}.cls-19{stroke-width:8.43px;}.cls-20{stroke-width:8.5px;}.cls-21{stroke-width:8.57px;}.cls-22{stroke-width:8.64px;}.cls-23{stroke-width:8.71px;}.cls-24{stroke-width:8.79px;}.cls-25{stroke-width:8.86px;}.cls-26{stroke-width:8.93px;}.cls-27{stroke-width:9px;}.cls-28{stroke-width:9.07px;}.cls-29{stroke-width:9.14px;}.cls-30{stroke-width:9.21px;}.cls-31{stroke-width:9.28px;}.cls-32{stroke-width:9.35px;}.cls-33{stroke-width:9.42px;}.cls-34{stroke-width:9.49px;}.cls-35{stroke-width:9.56px;}.cls-36{stroke-width:9.63px;}.cls-37{stroke-width:9.7px;}.cls-38{stroke-width:9.77px;}.cls-39{stroke-width:9.85px;}.cls-40{stroke-width:9.92px;}.cls-41{stroke-width:9.99px;}.cls-42{stroke-width:10.06px;}.cls-43{stroke-width:10.13px;}.cls-44{stroke-width:10.2px;}.cls-45{stroke-width:10.27px;}.cls-46{stroke-width:10.34px;}.cls-47{stroke-width:10.41px;}.cls-48{stroke-width:10.48px;}.cls-49{stroke-width:10.55px;}.cls-50{stroke-width:10.62px;}.cls-51{stroke-width:10.69px;}.cls-52{stroke-width:10.76px;}.cls-53{stroke-width:10.84px;}.cls-54{stroke-width:10.91px;}.cls-55{stroke-width:10.98px;}.cls-56{stroke-width:11.05px;}.cls-57{stroke-width:11.12px;}.cls-58{stroke-width:11.19px;}.cls-59{stroke-width:11.26px;}.cls-60{stroke-width:11.33px;}.cls-61{stroke-width:11.4px;}.cls-62{stroke-width:11.47px;}.cls-63{stroke-width:11.54px;}.cls-64{stroke-width:11.61px;}.cls-65{stroke-width:11.68px;}.cls-66{stroke-width:11.75px;}.cls-67{stroke-width:11.83px;}.cls-68{stroke-width:11.9px;}.cls-69{stroke-width:11.97px;}.cls-70{stroke-width:12.04px;}.cls-71{stroke-width:12.11px;}.cls-72{stroke-width:12.18px;}.cls-73{stroke-width:12.25px;}.cls-74{stroke-width:12.32px;}.cls-75{stroke-width:12.39px;}.cls-76{stroke-width:12.46px;}.cls-77{stroke-width:12.53px;}.cls-78{stroke-width:12.6px;}.cls-79{stroke-width:12.67px;}.cls-80{stroke-width:12.74px;}.cls-81{stroke-width:12.81px;}.cls-82{stroke-width:12.89px;}.cls-83{stroke-width:12.96px;}.cls-84{stroke-width:13.03px;}.cls-85{stroke-width:13.1px;}.cls-86{stroke-width:13.17px;}.cls-87{stroke-width:13.24px;}.cls-88{stroke-width:13.31px;}.cls-89{stroke-width:13.38px;}.cls-90{stroke-width:13.45px;}.cls-91{stroke-width:13.52px;}.cls-92{stroke-width:13.59px;}.cls-93{stroke-width:13.66px;}.cls-94{stroke-width:13.73px;}.cls-95{stroke-width:13.8px;}.cls-96{stroke-width:13.88px;}.cls-97{stroke-width:13.95px;}.cls-98{stroke-width:14.02px;}.cls-99{stroke-width:14.09px;}.cls-100{fill:#fff;}.cls-101{fill:url(#_50_to_100_Dot_Gradation);}"), /*#__PURE__*/React.createElement("pattern", {
    id: "_50_to_100_Dot_Gradation",
    "data-name": "50% to 100% Dot Gradation",
    width: 146.25,
    height: 708.75,
    patternTransform: "translate(1106.09 -2565.34) scale(1.58)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 146.25 708.75"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 146.25,
    height: 708.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 131.75,
    y1: 708.75,
    x2: 177.75,
    y2: 708.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 102.5,
    y1: 708.75,
    x2: 148.5,
    y2: 708.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 73.25,
    y1: 708.75,
    x2: 119.25,
    y2: 708.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 44,
    y1: 708.75,
    x2: 90,
    y2: 708.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 14.75,
    y1: 708.75,
    x2: 60.75,
    y2: 708.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: -14.5,
    y1: 708.75,
    x2: 31.5,
    y2: 708.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: -43.75,
    y1: 708.75,
    x2: 2.25,
    y2: 708.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 139.05,
    y1: 709.25,
    x2: 185.05,
    y2: 709.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 131.75,
    y1: 701.93,
    x2: 177.75,
    y2: 701.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 139.05,
    y1: 694.62,
    x2: 185.05,
    y2: 694.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 131.75,
    y1: 687.31,
    x2: 177.75,
    y2: 687.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 139.05,
    y1: 680,
    x2: 185.05,
    y2: 680
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 131.75,
    y1: 672.69,
    x2: 177.75,
    y2: 672.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 139.05,
    y1: 665.37,
    x2: 185.05,
    y2: 665.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 131.75,
    y1: 658.06,
    x2: 177.75,
    y2: 658.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 139.05,
    y1: 650.75,
    x2: 185.05,
    y2: 650.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 131.75,
    y1: 643.44,
    x2: 177.75,
    y2: 643.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 139.05,
    y1: 636.13,
    x2: 185.05,
    y2: 636.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 131.75,
    y1: 628.82,
    x2: 177.75,
    y2: 628.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 139.05,
    y1: 621.5,
    x2: 185.05,
    y2: 621.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 131.75,
    y1: 614.19,
    x2: 177.75,
    y2: 614.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 139.05,
    y1: 606.88,
    x2: 185.05,
    y2: 606.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 131.75,
    y1: 599.57,
    x2: 177.75,
    y2: 599.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 139.05,
    y1: 592.26,
    x2: 185.05,
    y2: 592.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 131.75,
    y1: 584.94,
    x2: 177.75,
    y2: 584.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 139.05,
    y1: 577.63,
    x2: 185.05,
    y2: 577.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 131.75,
    y1: 570.32,
    x2: 177.75,
    y2: 570.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 139.05,
    y1: 563.01,
    x2: 185.05,
    y2: 563.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 131.75,
    y1: 555.7,
    x2: 177.75,
    y2: 555.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-25",
    x1: 139.05,
    y1: 548.39,
    x2: 185.05,
    y2: 548.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 131.75,
    y1: 541.07,
    x2: 177.75,
    y2: 541.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-27",
    x1: 139.05,
    y1: 533.76,
    x2: 185.05,
    y2: 533.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-28",
    x1: 131.75,
    y1: 526.45,
    x2: 177.75,
    y2: 526.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 139.05,
    y1: 519.14,
    x2: 185.05,
    y2: 519.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-30",
    x1: 131.75,
    y1: 511.83,
    x2: 177.75,
    y2: 511.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-31",
    x1: 139.05,
    y1: 504.51,
    x2: 185.05,
    y2: 504.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-32",
    x1: 131.75,
    y1: 497.2,
    x2: 177.75,
    y2: 497.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-33",
    x1: 139.05,
    y1: 489.89,
    x2: 185.05,
    y2: 489.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-34",
    x1: 131.75,
    y1: 482.58,
    x2: 177.75,
    y2: 482.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-35",
    x1: 139.05,
    y1: 475.27,
    x2: 185.05,
    y2: 475.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-36",
    x1: 131.75,
    y1: 467.96,
    x2: 177.75,
    y2: 467.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-37",
    x1: 139.05,
    y1: 460.64,
    x2: 185.05,
    y2: 460.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-38",
    x1: 131.75,
    y1: 453.33,
    x2: 177.75,
    y2: 453.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-39",
    x1: 139.05,
    y1: 446.02,
    x2: 185.05,
    y2: 446.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-40",
    x1: 131.75,
    y1: 438.71,
    x2: 177.75,
    y2: 438.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-41",
    x1: 139.05,
    y1: 431.4,
    x2: 185.05,
    y2: 431.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-42",
    x1: 131.75,
    y1: 424.08,
    x2: 177.75,
    y2: 424.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-43",
    x1: 139.05,
    y1: 416.77,
    x2: 185.05,
    y2: 416.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-44",
    x1: 131.75,
    y1: 409.46,
    x2: 177.75,
    y2: 409.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-45",
    x1: 139.05,
    y1: 402.15,
    x2: 185.05,
    y2: 402.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-46",
    x1: 131.75,
    y1: 394.84,
    x2: 177.75,
    y2: 394.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-47",
    x1: 139.05,
    y1: 387.52,
    x2: 185.05,
    y2: 387.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-48",
    x1: 131.75,
    y1: 380.21,
    x2: 177.75,
    y2: 380.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-49",
    x1: 139.05,
    y1: 372.9,
    x2: 185.05,
    y2: 372.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-50",
    x1: 131.75,
    y1: 365.59,
    x2: 177.75,
    y2: 365.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-51",
    x1: 139.05,
    y1: 358.28,
    x2: 185.05,
    y2: 358.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-52",
    x1: 131.75,
    y1: 350.97,
    x2: 177.75,
    y2: 350.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-53",
    x1: 139.05,
    y1: 343.65,
    x2: 185.05,
    y2: 343.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-54",
    x1: 131.75,
    y1: 336.34,
    x2: 177.75,
    y2: 336.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-55",
    x1: 139.05,
    y1: 329.03,
    x2: 185.05,
    y2: 329.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-56",
    x1: 131.75,
    y1: 321.72,
    x2: 177.75,
    y2: 321.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-57",
    x1: 139.05,
    y1: 314.41,
    x2: 185.05,
    y2: 314.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-58",
    x1: 131.75,
    y1: 307.1,
    x2: 177.75,
    y2: 307.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-59",
    x1: 139.05,
    y1: 299.78,
    x2: 185.05,
    y2: 299.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-60",
    x1: 131.75,
    y1: 292.47,
    x2: 177.75,
    y2: 292.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-61",
    x1: 139.05,
    y1: 285.16,
    x2: 185.05,
    y2: 285.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-62",
    x1: 131.75,
    y1: 277.85,
    x2: 177.75,
    y2: 277.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-63",
    x1: 139.05,
    y1: 270.54,
    x2: 185.05,
    y2: 270.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-64",
    x1: 131.75,
    y1: 263.23,
    x2: 177.75,
    y2: 263.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-65",
    x1: 139.05,
    y1: 255.91,
    x2: 185.05,
    y2: 255.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-66",
    x1: 131.75,
    y1: 248.6,
    x2: 177.75,
    y2: 248.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-67",
    x1: 139.05,
    y1: 241.29,
    x2: 185.05,
    y2: 241.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-68",
    x1: 131.75,
    y1: 233.98,
    x2: 177.75,
    y2: 233.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-69",
    x1: 139.05,
    y1: 226.67,
    x2: 185.05,
    y2: 226.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-70",
    x1: 131.75,
    y1: 219.35,
    x2: 177.75,
    y2: 219.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-71",
    x1: 139.05,
    y1: 212.04,
    x2: 185.05,
    y2: 212.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-72",
    x1: 131.75,
    y1: 204.73,
    x2: 177.75,
    y2: 204.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-73",
    x1: 139.05,
    y1: 197.42,
    x2: 185.05,
    y2: 197.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-74",
    x1: 131.75,
    y1: 190.11,
    x2: 177.75,
    y2: 190.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-75",
    x1: 139.05,
    y1: 182.8,
    x2: 185.05,
    y2: 182.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-76",
    x1: 131.75,
    y1: 175.48,
    x2: 177.75,
    y2: 175.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-77",
    x1: 139.05,
    y1: 168.17,
    x2: 185.05,
    y2: 168.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-78",
    x1: 131.75,
    y1: 160.86,
    x2: 177.75,
    y2: 160.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-79",
    x1: 139.05,
    y1: 153.55,
    x2: 185.05,
    y2: 153.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-80",
    x1: 131.75,
    y1: 146.24,
    x2: 177.75,
    y2: 146.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-81",
    x1: 139.05,
    y1: 138.92,
    x2: 185.05,
    y2: 138.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-82",
    x1: 131.75,
    y1: 131.61,
    x2: 177.75,
    y2: 131.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-83",
    x1: 139.05,
    y1: 124.3,
    x2: 185.05,
    y2: 124.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-84",
    x1: 131.75,
    y1: 116.99,
    x2: 177.75,
    y2: 116.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-85",
    x1: 139.05,
    y1: 109.68,
    x2: 185.05,
    y2: 109.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-86",
    x1: 131.75,
    y1: 102.37,
    x2: 177.75,
    y2: 102.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-87",
    x1: 139.05,
    y1: 95.05,
    x2: 185.05,
    y2: 95.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-88",
    x1: 131.75,
    y1: 87.74,
    x2: 177.75,
    y2: 87.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-89",
    x1: 139.05,
    y1: 80.43,
    x2: 185.05,
    y2: 80.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-90",
    x1: 131.75,
    y1: 73.12,
    x2: 177.75,
    y2: 73.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-91",
    x1: 139.05,
    y1: 65.81,
    x2: 185.05,
    y2: 65.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-92",
    x1: 131.75,
    y1: 58.49,
    x2: 177.75,
    y2: 58.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-93",
    x1: 139.05,
    y1: 51.18,
    x2: 185.05,
    y2: 51.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-94",
    x1: 131.75,
    y1: 43.87,
    x2: 177.75,
    y2: 43.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-95",
    x1: 139.05,
    y1: 36.56,
    x2: 185.05,
    y2: 36.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-96",
    x1: 131.75,
    y1: 29.25,
    x2: 177.75,
    y2: 29.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-97",
    x1: 139.05,
    y1: 21.94,
    x2: 185.05,
    y2: 21.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-98",
    x1: 131.75,
    y1: 14.62,
    x2: 177.75,
    y2: 14.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-99",
    x1: 139.05,
    y1: 7.31,
    x2: 185.05,
    y2: 7.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 131.75,
    x2: 177.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 109.8,
    y1: 709.25,
    x2: 155.8,
    y2: 709.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 102.5,
    y1: 701.93,
    x2: 148.5,
    y2: 701.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 109.8,
    y1: 694.62,
    x2: 155.8,
    y2: 694.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 102.5,
    y1: 687.31,
    x2: 148.5,
    y2: 687.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 109.8,
    y1: 680,
    x2: 155.8,
    y2: 680
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 102.5,
    y1: 672.69,
    x2: 148.5,
    y2: 672.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 109.8,
    y1: 665.37,
    x2: 155.8,
    y2: 665.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 102.5,
    y1: 658.06,
    x2: 148.5,
    y2: 658.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 109.8,
    y1: 650.75,
    x2: 155.8,
    y2: 650.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 102.5,
    y1: 643.44,
    x2: 148.5,
    y2: 643.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 109.8,
    y1: 636.13,
    x2: 155.8,
    y2: 636.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 102.5,
    y1: 628.82,
    x2: 148.5,
    y2: 628.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 109.8,
    y1: 621.5,
    x2: 155.8,
    y2: 621.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 102.5,
    y1: 614.19,
    x2: 148.5,
    y2: 614.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 109.8,
    y1: 606.88,
    x2: 155.8,
    y2: 606.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 102.5,
    y1: 599.57,
    x2: 148.5,
    y2: 599.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 109.8,
    y1: 592.26,
    x2: 155.8,
    y2: 592.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 102.5,
    y1: 584.94,
    x2: 148.5,
    y2: 584.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 109.8,
    y1: 577.63,
    x2: 155.8,
    y2: 577.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 102.5,
    y1: 570.32,
    x2: 148.5,
    y2: 570.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 109.8,
    y1: 563.01,
    x2: 155.8,
    y2: 563.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 102.5,
    y1: 555.7,
    x2: 148.5,
    y2: 555.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-25",
    x1: 109.8,
    y1: 548.39,
    x2: 155.8,
    y2: 548.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 102.5,
    y1: 541.07,
    x2: 148.5,
    y2: 541.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-27",
    x1: 109.8,
    y1: 533.76,
    x2: 155.8,
    y2: 533.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-28",
    x1: 102.5,
    y1: 526.45,
    x2: 148.5,
    y2: 526.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 109.8,
    y1: 519.14,
    x2: 155.8,
    y2: 519.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-30",
    x1: 102.5,
    y1: 511.83,
    x2: 148.5,
    y2: 511.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-31",
    x1: 109.8,
    y1: 504.51,
    x2: 155.8,
    y2: 504.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-32",
    x1: 102.5,
    y1: 497.2,
    x2: 148.5,
    y2: 497.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-33",
    x1: 109.8,
    y1: 489.89,
    x2: 155.8,
    y2: 489.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-34",
    x1: 102.5,
    y1: 482.58,
    x2: 148.5,
    y2: 482.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-35",
    x1: 109.8,
    y1: 475.27,
    x2: 155.8,
    y2: 475.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-36",
    x1: 102.5,
    y1: 467.96,
    x2: 148.5,
    y2: 467.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-37",
    x1: 109.8,
    y1: 460.64,
    x2: 155.8,
    y2: 460.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-38",
    x1: 102.5,
    y1: 453.33,
    x2: 148.5,
    y2: 453.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-39",
    x1: 109.8,
    y1: 446.02,
    x2: 155.8,
    y2: 446.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-40",
    x1: 102.5,
    y1: 438.71,
    x2: 148.5,
    y2: 438.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-41",
    x1: 109.8,
    y1: 431.4,
    x2: 155.8,
    y2: 431.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-42",
    x1: 102.5,
    y1: 424.08,
    x2: 148.5,
    y2: 424.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-43",
    x1: 109.8,
    y1: 416.77,
    x2: 155.8,
    y2: 416.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-44",
    x1: 102.5,
    y1: 409.46,
    x2: 148.5,
    y2: 409.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-45",
    x1: 109.8,
    y1: 402.15,
    x2: 155.8,
    y2: 402.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-46",
    x1: 102.5,
    y1: 394.84,
    x2: 148.5,
    y2: 394.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-47",
    x1: 109.8,
    y1: 387.52,
    x2: 155.8,
    y2: 387.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-48",
    x1: 102.5,
    y1: 380.21,
    x2: 148.5,
    y2: 380.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-49",
    x1: 109.8,
    y1: 372.9,
    x2: 155.8,
    y2: 372.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-50",
    x1: 102.5,
    y1: 365.59,
    x2: 148.5,
    y2: 365.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-51",
    x1: 109.8,
    y1: 358.28,
    x2: 155.8,
    y2: 358.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-52",
    x1: 102.5,
    y1: 350.97,
    x2: 148.5,
    y2: 350.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-53",
    x1: 109.8,
    y1: 343.65,
    x2: 155.8,
    y2: 343.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-54",
    x1: 102.5,
    y1: 336.34,
    x2: 148.5,
    y2: 336.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-55",
    x1: 109.8,
    y1: 329.03,
    x2: 155.8,
    y2: 329.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-56",
    x1: 102.5,
    y1: 321.72,
    x2: 148.5,
    y2: 321.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-57",
    x1: 109.8,
    y1: 314.41,
    x2: 155.8,
    y2: 314.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-58",
    x1: 102.5,
    y1: 307.1,
    x2: 148.5,
    y2: 307.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-59",
    x1: 109.8,
    y1: 299.78,
    x2: 155.8,
    y2: 299.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-60",
    x1: 102.5,
    y1: 292.47,
    x2: 148.5,
    y2: 292.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-61",
    x1: 109.8,
    y1: 285.16,
    x2: 155.8,
    y2: 285.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-62",
    x1: 102.5,
    y1: 277.85,
    x2: 148.5,
    y2: 277.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-63",
    x1: 109.8,
    y1: 270.54,
    x2: 155.8,
    y2: 270.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-64",
    x1: 102.5,
    y1: 263.23,
    x2: 148.5,
    y2: 263.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-65",
    x1: 109.8,
    y1: 255.91,
    x2: 155.8,
    y2: 255.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-66",
    x1: 102.5,
    y1: 248.6,
    x2: 148.5,
    y2: 248.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-67",
    x1: 109.8,
    y1: 241.29,
    x2: 155.8,
    y2: 241.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-68",
    x1: 102.5,
    y1: 233.98,
    x2: 148.5,
    y2: 233.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-69",
    x1: 109.8,
    y1: 226.67,
    x2: 155.8,
    y2: 226.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-70",
    x1: 102.5,
    y1: 219.35,
    x2: 148.5,
    y2: 219.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-71",
    x1: 109.8,
    y1: 212.04,
    x2: 155.8,
    y2: 212.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-72",
    x1: 102.5,
    y1: 204.73,
    x2: 148.5,
    y2: 204.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-73",
    x1: 109.8,
    y1: 197.42,
    x2: 155.8,
    y2: 197.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-74",
    x1: 102.5,
    y1: 190.11,
    x2: 148.5,
    y2: 190.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-75",
    x1: 109.8,
    y1: 182.8,
    x2: 155.8,
    y2: 182.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-76",
    x1: 102.5,
    y1: 175.48,
    x2: 148.5,
    y2: 175.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-77",
    x1: 109.8,
    y1: 168.17,
    x2: 155.8,
    y2: 168.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-78",
    x1: 102.5,
    y1: 160.86,
    x2: 148.5,
    y2: 160.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-79",
    x1: 109.8,
    y1: 153.55,
    x2: 155.8,
    y2: 153.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-80",
    x1: 102.5,
    y1: 146.24,
    x2: 148.5,
    y2: 146.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-81",
    x1: 109.8,
    y1: 138.92,
    x2: 155.8,
    y2: 138.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-82",
    x1: 102.5,
    y1: 131.61,
    x2: 148.5,
    y2: 131.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-83",
    x1: 109.8,
    y1: 124.3,
    x2: 155.8,
    y2: 124.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-84",
    x1: 102.5,
    y1: 116.99,
    x2: 148.5,
    y2: 116.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-85",
    x1: 109.8,
    y1: 109.68,
    x2: 155.8,
    y2: 109.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-86",
    x1: 102.5,
    y1: 102.37,
    x2: 148.5,
    y2: 102.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-87",
    x1: 109.8,
    y1: 95.05,
    x2: 155.8,
    y2: 95.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-88",
    x1: 102.5,
    y1: 87.74,
    x2: 148.5,
    y2: 87.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-89",
    x1: 109.8,
    y1: 80.43,
    x2: 155.8,
    y2: 80.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-90",
    x1: 102.5,
    y1: 73.12,
    x2: 148.5,
    y2: 73.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-91",
    x1: 109.8,
    y1: 65.81,
    x2: 155.8,
    y2: 65.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-92",
    x1: 102.5,
    y1: 58.49,
    x2: 148.5,
    y2: 58.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-93",
    x1: 109.8,
    y1: 51.18,
    x2: 155.8,
    y2: 51.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-94",
    x1: 102.5,
    y1: 43.87,
    x2: 148.5,
    y2: 43.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-95",
    x1: 109.8,
    y1: 36.56,
    x2: 155.8,
    y2: 36.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-96",
    x1: 102.5,
    y1: 29.25,
    x2: 148.5,
    y2: 29.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-97",
    x1: 109.8,
    y1: 21.94,
    x2: 155.8,
    y2: 21.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-98",
    x1: 102.5,
    y1: 14.62,
    x2: 148.5,
    y2: 14.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-99",
    x1: 109.8,
    y1: 7.31,
    x2: 155.8,
    y2: 7.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 102.5,
    x2: 148.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 80.55,
    y1: 709.25,
    x2: 126.55,
    y2: 709.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 73.25,
    y1: 701.93,
    x2: 119.25,
    y2: 701.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 80.55,
    y1: 694.62,
    x2: 126.55,
    y2: 694.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 73.25,
    y1: 687.31,
    x2: 119.25,
    y2: 687.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 80.55,
    y1: 680,
    x2: 126.55,
    y2: 680
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 73.25,
    y1: 672.69,
    x2: 119.25,
    y2: 672.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 80.55,
    y1: 665.37,
    x2: 126.55,
    y2: 665.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 73.25,
    y1: 658.06,
    x2: 119.25,
    y2: 658.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 80.55,
    y1: 650.75,
    x2: 126.55,
    y2: 650.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 73.25,
    y1: 643.44,
    x2: 119.25,
    y2: 643.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 80.55,
    y1: 636.13,
    x2: 126.55,
    y2: 636.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 73.25,
    y1: 628.82,
    x2: 119.25,
    y2: 628.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 80.55,
    y1: 621.5,
    x2: 126.55,
    y2: 621.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 73.25,
    y1: 614.19,
    x2: 119.25,
    y2: 614.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 80.55,
    y1: 606.88,
    x2: 126.55,
    y2: 606.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 73.25,
    y1: 599.57,
    x2: 119.25,
    y2: 599.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 80.55,
    y1: 592.26,
    x2: 126.55,
    y2: 592.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 73.25,
    y1: 584.94,
    x2: 119.25,
    y2: 584.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 80.55,
    y1: 577.63,
    x2: 126.55,
    y2: 577.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 73.25,
    y1: 570.32,
    x2: 119.25,
    y2: 570.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 80.55,
    y1: 563.01,
    x2: 126.55,
    y2: 563.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 73.25,
    y1: 555.7,
    x2: 119.25,
    y2: 555.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-25",
    x1: 80.55,
    y1: 548.39,
    x2: 126.55,
    y2: 548.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 73.25,
    y1: 541.07,
    x2: 119.25,
    y2: 541.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-27",
    x1: 80.55,
    y1: 533.76,
    x2: 126.55,
    y2: 533.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-28",
    x1: 73.25,
    y1: 526.45,
    x2: 119.25,
    y2: 526.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 80.55,
    y1: 519.14,
    x2: 126.55,
    y2: 519.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-30",
    x1: 73.25,
    y1: 511.83,
    x2: 119.25,
    y2: 511.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-31",
    x1: 80.55,
    y1: 504.51,
    x2: 126.55,
    y2: 504.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-32",
    x1: 73.25,
    y1: 497.2,
    x2: 119.25,
    y2: 497.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-33",
    x1: 80.55,
    y1: 489.89,
    x2: 126.55,
    y2: 489.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-34",
    x1: 73.25,
    y1: 482.58,
    x2: 119.25,
    y2: 482.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-35",
    x1: 80.55,
    y1: 475.27,
    x2: 126.55,
    y2: 475.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-36",
    x1: 73.25,
    y1: 467.96,
    x2: 119.25,
    y2: 467.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-37",
    x1: 80.55,
    y1: 460.64,
    x2: 126.55,
    y2: 460.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-38",
    x1: 73.25,
    y1: 453.33,
    x2: 119.25,
    y2: 453.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-39",
    x1: 80.55,
    y1: 446.02,
    x2: 126.55,
    y2: 446.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-40",
    x1: 73.25,
    y1: 438.71,
    x2: 119.25,
    y2: 438.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-41",
    x1: 80.55,
    y1: 431.4,
    x2: 126.55,
    y2: 431.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-42",
    x1: 73.25,
    y1: 424.08,
    x2: 119.25,
    y2: 424.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-43",
    x1: 80.55,
    y1: 416.77,
    x2: 126.55,
    y2: 416.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-44",
    x1: 73.25,
    y1: 409.46,
    x2: 119.25,
    y2: 409.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-45",
    x1: 80.55,
    y1: 402.15,
    x2: 126.55,
    y2: 402.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-46",
    x1: 73.25,
    y1: 394.84,
    x2: 119.25,
    y2: 394.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-47",
    x1: 80.55,
    y1: 387.52,
    x2: 126.55,
    y2: 387.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-48",
    x1: 73.25,
    y1: 380.21,
    x2: 119.25,
    y2: 380.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-49",
    x1: 80.55,
    y1: 372.9,
    x2: 126.55,
    y2: 372.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-50",
    x1: 73.25,
    y1: 365.59,
    x2: 119.25,
    y2: 365.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-51",
    x1: 80.55,
    y1: 358.28,
    x2: 126.55,
    y2: 358.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-52",
    x1: 73.25,
    y1: 350.97,
    x2: 119.25,
    y2: 350.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-53",
    x1: 80.55,
    y1: 343.65,
    x2: 126.55,
    y2: 343.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-54",
    x1: 73.25,
    y1: 336.34,
    x2: 119.25,
    y2: 336.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-55",
    x1: 80.55,
    y1: 329.03,
    x2: 126.55,
    y2: 329.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-56",
    x1: 73.25,
    y1: 321.72,
    x2: 119.25,
    y2: 321.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-57",
    x1: 80.55,
    y1: 314.41,
    x2: 126.55,
    y2: 314.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-58",
    x1: 73.25,
    y1: 307.1,
    x2: 119.25,
    y2: 307.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-59",
    x1: 80.55,
    y1: 299.78,
    x2: 126.55,
    y2: 299.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-60",
    x1: 73.25,
    y1: 292.47,
    x2: 119.25,
    y2: 292.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-61",
    x1: 80.55,
    y1: 285.16,
    x2: 126.55,
    y2: 285.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-62",
    x1: 73.25,
    y1: 277.85,
    x2: 119.25,
    y2: 277.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-63",
    x1: 80.55,
    y1: 270.54,
    x2: 126.55,
    y2: 270.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-64",
    x1: 73.25,
    y1: 263.23,
    x2: 119.25,
    y2: 263.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-65",
    x1: 80.55,
    y1: 255.91,
    x2: 126.55,
    y2: 255.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-66",
    x1: 73.25,
    y1: 248.6,
    x2: 119.25,
    y2: 248.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-67",
    x1: 80.55,
    y1: 241.29,
    x2: 126.55,
    y2: 241.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-68",
    x1: 73.25,
    y1: 233.98,
    x2: 119.25,
    y2: 233.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-69",
    x1: 80.55,
    y1: 226.67,
    x2: 126.55,
    y2: 226.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-70",
    x1: 73.25,
    y1: 219.35,
    x2: 119.25,
    y2: 219.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-71",
    x1: 80.55,
    y1: 212.04,
    x2: 126.55,
    y2: 212.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-72",
    x1: 73.25,
    y1: 204.73,
    x2: 119.25,
    y2: 204.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-73",
    x1: 80.55,
    y1: 197.42,
    x2: 126.55,
    y2: 197.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-74",
    x1: 73.25,
    y1: 190.11,
    x2: 119.25,
    y2: 190.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-75",
    x1: 80.55,
    y1: 182.8,
    x2: 126.55,
    y2: 182.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-76",
    x1: 73.25,
    y1: 175.48,
    x2: 119.25,
    y2: 175.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-77",
    x1: 80.55,
    y1: 168.17,
    x2: 126.55,
    y2: 168.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-78",
    x1: 73.25,
    y1: 160.86,
    x2: 119.25,
    y2: 160.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-79",
    x1: 80.55,
    y1: 153.55,
    x2: 126.55,
    y2: 153.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-80",
    x1: 73.25,
    y1: 146.24,
    x2: 119.25,
    y2: 146.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-81",
    x1: 80.55,
    y1: 138.92,
    x2: 126.55,
    y2: 138.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-82",
    x1: 73.25,
    y1: 131.61,
    x2: 119.25,
    y2: 131.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-83",
    x1: 80.55,
    y1: 124.3,
    x2: 126.55,
    y2: 124.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-84",
    x1: 73.25,
    y1: 116.99,
    x2: 119.25,
    y2: 116.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-85",
    x1: 80.55,
    y1: 109.68,
    x2: 126.55,
    y2: 109.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-86",
    x1: 73.25,
    y1: 102.37,
    x2: 119.25,
    y2: 102.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-87",
    x1: 80.55,
    y1: 95.05,
    x2: 126.55,
    y2: 95.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-88",
    x1: 73.25,
    y1: 87.74,
    x2: 119.25,
    y2: 87.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-89",
    x1: 80.55,
    y1: 80.43,
    x2: 126.55,
    y2: 80.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-90",
    x1: 73.25,
    y1: 73.12,
    x2: 119.25,
    y2: 73.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-91",
    x1: 80.55,
    y1: 65.81,
    x2: 126.55,
    y2: 65.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-92",
    x1: 73.25,
    y1: 58.49,
    x2: 119.25,
    y2: 58.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-93",
    x1: 80.55,
    y1: 51.18,
    x2: 126.55,
    y2: 51.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-94",
    x1: 73.25,
    y1: 43.87,
    x2: 119.25,
    y2: 43.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-95",
    x1: 80.55,
    y1: 36.56,
    x2: 126.55,
    y2: 36.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-96",
    x1: 73.25,
    y1: 29.25,
    x2: 119.25,
    y2: 29.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-97",
    x1: 80.55,
    y1: 21.94,
    x2: 126.55,
    y2: 21.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-98",
    x1: 73.25,
    y1: 14.62,
    x2: 119.25,
    y2: 14.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-99",
    x1: 80.55,
    y1: 7.31,
    x2: 126.55,
    y2: 7.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 73.25,
    x2: 119.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 51.3,
    y1: 709.25,
    x2: 97.3,
    y2: 709.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 44,
    y1: 701.93,
    x2: 90,
    y2: 701.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 51.3,
    y1: 694.62,
    x2: 97.3,
    y2: 694.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 44,
    y1: 687.31,
    x2: 90,
    y2: 687.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 51.3,
    y1: 680,
    x2: 97.3,
    y2: 680
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 44,
    y1: 672.69,
    x2: 90,
    y2: 672.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 51.3,
    y1: 665.37,
    x2: 97.3,
    y2: 665.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 44,
    y1: 658.06,
    x2: 90,
    y2: 658.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 51.3,
    y1: 650.75,
    x2: 97.3,
    y2: 650.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 44,
    y1: 643.44,
    x2: 90,
    y2: 643.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 51.3,
    y1: 636.13,
    x2: 97.3,
    y2: 636.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 44,
    y1: 628.82,
    x2: 90,
    y2: 628.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 51.3,
    y1: 621.5,
    x2: 97.3,
    y2: 621.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 44,
    y1: 614.19,
    x2: 90,
    y2: 614.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 51.3,
    y1: 606.88,
    x2: 97.3,
    y2: 606.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 44,
    y1: 599.57,
    x2: 90,
    y2: 599.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 51.3,
    y1: 592.26,
    x2: 97.3,
    y2: 592.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 44,
    y1: 584.94,
    x2: 90,
    y2: 584.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 51.3,
    y1: 577.63,
    x2: 97.3,
    y2: 577.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 44,
    y1: 570.32,
    x2: 90,
    y2: 570.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 51.3,
    y1: 563.01,
    x2: 97.3,
    y2: 563.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 44,
    y1: 555.7,
    x2: 90,
    y2: 555.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-25",
    x1: 51.3,
    y1: 548.39,
    x2: 97.3,
    y2: 548.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 44,
    y1: 541.07,
    x2: 90,
    y2: 541.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-27",
    x1: 51.3,
    y1: 533.76,
    x2: 97.3,
    y2: 533.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-28",
    x1: 44,
    y1: 526.45,
    x2: 90,
    y2: 526.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 51.3,
    y1: 519.14,
    x2: 97.3,
    y2: 519.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-30",
    x1: 44,
    y1: 511.83,
    x2: 90,
    y2: 511.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-31",
    x1: 51.3,
    y1: 504.51,
    x2: 97.3,
    y2: 504.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-32",
    x1: 44,
    y1: 497.2,
    x2: 90,
    y2: 497.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-33",
    x1: 51.3,
    y1: 489.89,
    x2: 97.3,
    y2: 489.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-34",
    x1: 44,
    y1: 482.58,
    x2: 90,
    y2: 482.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-35",
    x1: 51.3,
    y1: 475.27,
    x2: 97.3,
    y2: 475.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-36",
    x1: 44,
    y1: 467.96,
    x2: 90,
    y2: 467.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-37",
    x1: 51.3,
    y1: 460.64,
    x2: 97.3,
    y2: 460.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-38",
    x1: 44,
    y1: 453.33,
    x2: 90,
    y2: 453.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-39",
    x1: 51.3,
    y1: 446.02,
    x2: 97.3,
    y2: 446.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-40",
    x1: 44,
    y1: 438.71,
    x2: 90,
    y2: 438.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-41",
    x1: 51.3,
    y1: 431.4,
    x2: 97.3,
    y2: 431.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-42",
    x1: 44,
    y1: 424.08,
    x2: 90,
    y2: 424.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-43",
    x1: 51.3,
    y1: 416.77,
    x2: 97.3,
    y2: 416.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-44",
    x1: 44,
    y1: 409.46,
    x2: 90,
    y2: 409.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-45",
    x1: 51.3,
    y1: 402.15,
    x2: 97.3,
    y2: 402.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-46",
    x1: 44,
    y1: 394.84,
    x2: 90,
    y2: 394.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-47",
    x1: 51.3,
    y1: 387.52,
    x2: 97.3,
    y2: 387.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-48",
    x1: 44,
    y1: 380.21,
    x2: 90,
    y2: 380.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-49",
    x1: 51.3,
    y1: 372.9,
    x2: 97.3,
    y2: 372.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-50",
    x1: 44,
    y1: 365.59,
    x2: 90,
    y2: 365.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-51",
    x1: 51.3,
    y1: 358.28,
    x2: 97.3,
    y2: 358.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-52",
    x1: 44,
    y1: 350.97,
    x2: 90,
    y2: 350.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-53",
    x1: 51.3,
    y1: 343.65,
    x2: 97.3,
    y2: 343.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-54",
    x1: 44,
    y1: 336.34,
    x2: 90,
    y2: 336.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-55",
    x1: 51.3,
    y1: 329.03,
    x2: 97.3,
    y2: 329.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-56",
    x1: 44,
    y1: 321.72,
    x2: 90,
    y2: 321.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-57",
    x1: 51.3,
    y1: 314.41,
    x2: 97.3,
    y2: 314.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-58",
    x1: 44,
    y1: 307.1,
    x2: 90,
    y2: 307.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-59",
    x1: 51.3,
    y1: 299.78,
    x2: 97.3,
    y2: 299.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-60",
    x1: 44,
    y1: 292.47,
    x2: 90,
    y2: 292.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-61",
    x1: 51.3,
    y1: 285.16,
    x2: 97.3,
    y2: 285.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-62",
    x1: 44,
    y1: 277.85,
    x2: 90,
    y2: 277.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-63",
    x1: 51.3,
    y1: 270.54,
    x2: 97.3,
    y2: 270.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-64",
    x1: 44,
    y1: 263.23,
    x2: 90,
    y2: 263.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-65",
    x1: 51.3,
    y1: 255.91,
    x2: 97.3,
    y2: 255.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-66",
    x1: 44,
    y1: 248.6,
    x2: 90,
    y2: 248.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-67",
    x1: 51.3,
    y1: 241.29,
    x2: 97.3,
    y2: 241.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-68",
    x1: 44,
    y1: 233.98,
    x2: 90,
    y2: 233.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-69",
    x1: 51.3,
    y1: 226.67,
    x2: 97.3,
    y2: 226.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-70",
    x1: 44,
    y1: 219.35,
    x2: 90,
    y2: 219.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-71",
    x1: 51.3,
    y1: 212.04,
    x2: 97.3,
    y2: 212.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-72",
    x1: 44,
    y1: 204.73,
    x2: 90,
    y2: 204.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-73",
    x1: 51.3,
    y1: 197.42,
    x2: 97.3,
    y2: 197.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-74",
    x1: 44,
    y1: 190.11,
    x2: 90,
    y2: 190.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-75",
    x1: 51.3,
    y1: 182.8,
    x2: 97.3,
    y2: 182.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-76",
    x1: 44,
    y1: 175.48,
    x2: 90,
    y2: 175.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-77",
    x1: 51.3,
    y1: 168.17,
    x2: 97.3,
    y2: 168.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-78",
    x1: 44,
    y1: 160.86,
    x2: 90,
    y2: 160.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-79",
    x1: 51.3,
    y1: 153.55,
    x2: 97.3,
    y2: 153.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-80",
    x1: 44,
    y1: 146.24,
    x2: 90,
    y2: 146.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-81",
    x1: 51.3,
    y1: 138.92,
    x2: 97.3,
    y2: 138.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-82",
    x1: 44,
    y1: 131.61,
    x2: 90,
    y2: 131.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-83",
    x1: 51.3,
    y1: 124.3,
    x2: 97.3,
    y2: 124.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-84",
    x1: 44,
    y1: 116.99,
    x2: 90,
    y2: 116.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-85",
    x1: 51.3,
    y1: 109.68,
    x2: 97.3,
    y2: 109.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-86",
    x1: 44,
    y1: 102.37,
    x2: 90,
    y2: 102.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-87",
    x1: 51.3,
    y1: 95.05,
    x2: 97.3,
    y2: 95.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-88",
    x1: 44,
    y1: 87.74,
    x2: 90,
    y2: 87.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-89",
    x1: 51.3,
    y1: 80.43,
    x2: 97.3,
    y2: 80.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-90",
    x1: 44,
    y1: 73.12,
    x2: 90,
    y2: 73.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-91",
    x1: 51.3,
    y1: 65.81,
    x2: 97.3,
    y2: 65.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-92",
    x1: 44,
    y1: 58.49,
    x2: 90,
    y2: 58.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-93",
    x1: 51.3,
    y1: 51.18,
    x2: 97.3,
    y2: 51.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-94",
    x1: 44,
    y1: 43.87,
    x2: 90,
    y2: 43.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-95",
    x1: 51.3,
    y1: 36.56,
    x2: 97.3,
    y2: 36.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-96",
    x1: 44,
    y1: 29.25,
    x2: 90,
    y2: 29.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-97",
    x1: 51.3,
    y1: 21.94,
    x2: 97.3,
    y2: 21.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-98",
    x1: 44,
    y1: 14.62,
    x2: 90,
    y2: 14.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-99",
    x1: 51.3,
    y1: 7.31,
    x2: 97.3,
    y2: 7.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 44,
    x2: 90
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 22.05,
    y1: 709.25,
    x2: 68.05,
    y2: 709.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 14.75,
    y1: 701.93,
    x2: 60.75,
    y2: 701.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 22.05,
    y1: 694.62,
    x2: 68.05,
    y2: 694.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 14.75,
    y1: 687.31,
    x2: 60.75,
    y2: 687.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 22.05,
    y1: 680,
    x2: 68.05,
    y2: 680
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 14.75,
    y1: 672.69,
    x2: 60.75,
    y2: 672.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 22.05,
    y1: 665.37,
    x2: 68.05,
    y2: 665.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 14.75,
    y1: 658.06,
    x2: 60.75,
    y2: 658.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 22.05,
    y1: 650.75,
    x2: 68.05,
    y2: 650.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 14.75,
    y1: 643.44,
    x2: 60.75,
    y2: 643.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 22.05,
    y1: 636.13,
    x2: 68.05,
    y2: 636.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 14.75,
    y1: 628.82,
    x2: 60.75,
    y2: 628.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 22.05,
    y1: 621.5,
    x2: 68.05,
    y2: 621.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 14.75,
    y1: 614.19,
    x2: 60.75,
    y2: 614.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 22.05,
    y1: 606.88,
    x2: 68.05,
    y2: 606.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 14.75,
    y1: 599.57,
    x2: 60.75,
    y2: 599.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 22.05,
    y1: 592.26,
    x2: 68.05,
    y2: 592.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 14.75,
    y1: 584.94,
    x2: 60.75,
    y2: 584.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 22.05,
    y1: 577.63,
    x2: 68.05,
    y2: 577.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 14.75,
    y1: 570.32,
    x2: 60.75,
    y2: 570.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 22.05,
    y1: 563.01,
    x2: 68.05,
    y2: 563.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 14.75,
    y1: 555.7,
    x2: 60.75,
    y2: 555.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-25",
    x1: 22.05,
    y1: 548.39,
    x2: 68.05,
    y2: 548.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 14.75,
    y1: 541.07,
    x2: 60.75,
    y2: 541.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-27",
    x1: 22.05,
    y1: 533.76,
    x2: 68.05,
    y2: 533.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-28",
    x1: 14.75,
    y1: 526.45,
    x2: 60.75,
    y2: 526.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 22.05,
    y1: 519.14,
    x2: 68.05,
    y2: 519.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-30",
    x1: 14.75,
    y1: 511.83,
    x2: 60.75,
    y2: 511.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-31",
    x1: 22.05,
    y1: 504.51,
    x2: 68.05,
    y2: 504.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-32",
    x1: 14.75,
    y1: 497.2,
    x2: 60.75,
    y2: 497.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-33",
    x1: 22.05,
    y1: 489.89,
    x2: 68.05,
    y2: 489.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-34",
    x1: 14.75,
    y1: 482.58,
    x2: 60.75,
    y2: 482.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-35",
    x1: 22.05,
    y1: 475.27,
    x2: 68.05,
    y2: 475.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-36",
    x1: 14.75,
    y1: 467.96,
    x2: 60.75,
    y2: 467.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-37",
    x1: 22.05,
    y1: 460.64,
    x2: 68.05,
    y2: 460.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-38",
    x1: 14.75,
    y1: 453.33,
    x2: 60.75,
    y2: 453.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-39",
    x1: 22.05,
    y1: 446.02,
    x2: 68.05,
    y2: 446.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-40",
    x1: 14.75,
    y1: 438.71,
    x2: 60.75,
    y2: 438.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-41",
    x1: 22.05,
    y1: 431.4,
    x2: 68.05,
    y2: 431.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-42",
    x1: 14.75,
    y1: 424.08,
    x2: 60.75,
    y2: 424.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-43",
    x1: 22.05,
    y1: 416.77,
    x2: 68.05,
    y2: 416.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-44",
    x1: 14.75,
    y1: 409.46,
    x2: 60.75,
    y2: 409.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-45",
    x1: 22.05,
    y1: 402.15,
    x2: 68.05,
    y2: 402.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-46",
    x1: 14.75,
    y1: 394.84,
    x2: 60.75,
    y2: 394.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-47",
    x1: 22.05,
    y1: 387.52,
    x2: 68.05,
    y2: 387.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-48",
    x1: 14.75,
    y1: 380.21,
    x2: 60.75,
    y2: 380.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-49",
    x1: 22.05,
    y1: 372.9,
    x2: 68.05,
    y2: 372.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-50",
    x1: 14.75,
    y1: 365.59,
    x2: 60.75,
    y2: 365.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-51",
    x1: 22.05,
    y1: 358.28,
    x2: 68.05,
    y2: 358.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-52",
    x1: 14.75,
    y1: 350.97,
    x2: 60.75,
    y2: 350.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-53",
    x1: 22.05,
    y1: 343.65,
    x2: 68.05,
    y2: 343.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-54",
    x1: 14.75,
    y1: 336.34,
    x2: 60.75,
    y2: 336.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-55",
    x1: 22.05,
    y1: 329.03,
    x2: 68.05,
    y2: 329.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-56",
    x1: 14.75,
    y1: 321.72,
    x2: 60.75,
    y2: 321.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-57",
    x1: 22.05,
    y1: 314.41,
    x2: 68.05,
    y2: 314.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-58",
    x1: 14.75,
    y1: 307.1,
    x2: 60.75,
    y2: 307.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-59",
    x1: 22.05,
    y1: 299.78,
    x2: 68.05,
    y2: 299.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-60",
    x1: 14.75,
    y1: 292.47,
    x2: 60.75,
    y2: 292.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-61",
    x1: 22.05,
    y1: 285.16,
    x2: 68.05,
    y2: 285.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-62",
    x1: 14.75,
    y1: 277.85,
    x2: 60.75,
    y2: 277.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-63",
    x1: 22.05,
    y1: 270.54,
    x2: 68.05,
    y2: 270.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-64",
    x1: 14.75,
    y1: 263.23,
    x2: 60.75,
    y2: 263.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-65",
    x1: 22.05,
    y1: 255.91,
    x2: 68.05,
    y2: 255.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-66",
    x1: 14.75,
    y1: 248.6,
    x2: 60.75,
    y2: 248.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-67",
    x1: 22.05,
    y1: 241.29,
    x2: 68.05,
    y2: 241.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-68",
    x1: 14.75,
    y1: 233.98,
    x2: 60.75,
    y2: 233.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-69",
    x1: 22.05,
    y1: 226.67,
    x2: 68.05,
    y2: 226.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-70",
    x1: 14.75,
    y1: 219.35,
    x2: 60.75,
    y2: 219.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-71",
    x1: 22.05,
    y1: 212.04,
    x2: 68.05,
    y2: 212.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-72",
    x1: 14.75,
    y1: 204.73,
    x2: 60.75,
    y2: 204.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-73",
    x1: 22.05,
    y1: 197.42,
    x2: 68.05,
    y2: 197.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-74",
    x1: 14.75,
    y1: 190.11,
    x2: 60.75,
    y2: 190.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-75",
    x1: 22.05,
    y1: 182.8,
    x2: 68.05,
    y2: 182.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-76",
    x1: 14.75,
    y1: 175.48,
    x2: 60.75,
    y2: 175.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-77",
    x1: 22.05,
    y1: 168.17,
    x2: 68.05,
    y2: 168.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-78",
    x1: 14.75,
    y1: 160.86,
    x2: 60.75,
    y2: 160.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-79",
    x1: 22.05,
    y1: 153.55,
    x2: 68.05,
    y2: 153.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-80",
    x1: 14.75,
    y1: 146.24,
    x2: 60.75,
    y2: 146.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-81",
    x1: 22.05,
    y1: 138.92,
    x2: 68.05,
    y2: 138.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-82",
    x1: 14.75,
    y1: 131.61,
    x2: 60.75,
    y2: 131.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-83",
    x1: 22.05,
    y1: 124.3,
    x2: 68.05,
    y2: 124.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-84",
    x1: 14.75,
    y1: 116.99,
    x2: 60.75,
    y2: 116.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-85",
    x1: 22.05,
    y1: 109.68,
    x2: 68.05,
    y2: 109.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-86",
    x1: 14.75,
    y1: 102.37,
    x2: 60.75,
    y2: 102.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-87",
    x1: 22.05,
    y1: 95.05,
    x2: 68.05,
    y2: 95.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-88",
    x1: 14.75,
    y1: 87.74,
    x2: 60.75,
    y2: 87.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-89",
    x1: 22.05,
    y1: 80.43,
    x2: 68.05,
    y2: 80.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-90",
    x1: 14.75,
    y1: 73.12,
    x2: 60.75,
    y2: 73.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-91",
    x1: 22.05,
    y1: 65.81,
    x2: 68.05,
    y2: 65.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-92",
    x1: 14.75,
    y1: 58.49,
    x2: 60.75,
    y2: 58.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-93",
    x1: 22.05,
    y1: 51.18,
    x2: 68.05,
    y2: 51.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-94",
    x1: 14.75,
    y1: 43.87,
    x2: 60.75,
    y2: 43.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-95",
    x1: 22.05,
    y1: 36.56,
    x2: 68.05,
    y2: 36.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-96",
    x1: 14.75,
    y1: 29.25,
    x2: 60.75,
    y2: 29.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-97",
    x1: 22.05,
    y1: 21.94,
    x2: 68.05,
    y2: 21.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-98",
    x1: 14.75,
    y1: 14.62,
    x2: 60.75,
    y2: 14.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-99",
    x1: 22.05,
    y1: 7.31,
    x2: 68.05,
    y2: 7.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 14.75,
    x2: 60.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: -7.2,
    y1: 709.25,
    x2: 38.8,
    y2: 709.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: -14.5,
    y1: 701.93,
    x2: 31.5,
    y2: 701.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: -7.2,
    y1: 694.62,
    x2: 38.8,
    y2: 694.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: -14.5,
    y1: 687.31,
    x2: 31.5,
    y2: 687.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: -7.2,
    y1: 680,
    x2: 38.8,
    y2: 680
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: -14.5,
    y1: 672.69,
    x2: 31.5,
    y2: 672.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: -7.2,
    y1: 665.37,
    x2: 38.8,
    y2: 665.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: -14.5,
    y1: 658.06,
    x2: 31.5,
    y2: 658.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: -7.2,
    y1: 650.75,
    x2: 38.8,
    y2: 650.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: -14.5,
    y1: 643.44,
    x2: 31.5,
    y2: 643.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: -7.2,
    y1: 636.13,
    x2: 38.8,
    y2: 636.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: -14.5,
    y1: 628.82,
    x2: 31.5,
    y2: 628.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: -7.2,
    y1: 621.5,
    x2: 38.8,
    y2: 621.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: -14.5,
    y1: 614.19,
    x2: 31.5,
    y2: 614.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: -7.2,
    y1: 606.88,
    x2: 38.8,
    y2: 606.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: -14.5,
    y1: 599.57,
    x2: 31.5,
    y2: 599.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: -7.2,
    y1: 592.26,
    x2: 38.8,
    y2: 592.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: -14.5,
    y1: 584.94,
    x2: 31.5,
    y2: 584.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: -7.2,
    y1: 577.63,
    x2: 38.8,
    y2: 577.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: -14.5,
    y1: 570.32,
    x2: 31.5,
    y2: 570.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: -7.2,
    y1: 563.01,
    x2: 38.8,
    y2: 563.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: -14.5,
    y1: 555.7,
    x2: 31.5,
    y2: 555.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-25",
    x1: -7.2,
    y1: 548.39,
    x2: 38.8,
    y2: 548.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: -14.5,
    y1: 541.07,
    x2: 31.5,
    y2: 541.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-27",
    x1: -7.2,
    y1: 533.76,
    x2: 38.8,
    y2: 533.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-28",
    x1: -14.5,
    y1: 526.45,
    x2: 31.5,
    y2: 526.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: -7.2,
    y1: 519.14,
    x2: 38.8,
    y2: 519.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-30",
    x1: -14.5,
    y1: 511.83,
    x2: 31.5,
    y2: 511.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-31",
    x1: -7.2,
    y1: 504.51,
    x2: 38.8,
    y2: 504.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-32",
    x1: -14.5,
    y1: 497.2,
    x2: 31.5,
    y2: 497.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-33",
    x1: -7.2,
    y1: 489.89,
    x2: 38.8,
    y2: 489.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-34",
    x1: -14.5,
    y1: 482.58,
    x2: 31.5,
    y2: 482.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-35",
    x1: -7.2,
    y1: 475.27,
    x2: 38.8,
    y2: 475.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-36",
    x1: -14.5,
    y1: 467.96,
    x2: 31.5,
    y2: 467.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-37",
    x1: -7.2,
    y1: 460.64,
    x2: 38.8,
    y2: 460.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-38",
    x1: -14.5,
    y1: 453.33,
    x2: 31.5,
    y2: 453.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-39",
    x1: -7.2,
    y1: 446.02,
    x2: 38.8,
    y2: 446.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-40",
    x1: -14.5,
    y1: 438.71,
    x2: 31.5,
    y2: 438.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-41",
    x1: -7.2,
    y1: 431.4,
    x2: 38.8,
    y2: 431.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-42",
    x1: -14.5,
    y1: 424.08,
    x2: 31.5,
    y2: 424.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-43",
    x1: -7.2,
    y1: 416.77,
    x2: 38.8,
    y2: 416.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-44",
    x1: -14.5,
    y1: 409.46,
    x2: 31.5,
    y2: 409.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-45",
    x1: -7.2,
    y1: 402.15,
    x2: 38.8,
    y2: 402.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-46",
    x1: -14.5,
    y1: 394.84,
    x2: 31.5,
    y2: 394.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-47",
    x1: -7.2,
    y1: 387.52,
    x2: 38.8,
    y2: 387.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-48",
    x1: -14.5,
    y1: 380.21,
    x2: 31.5,
    y2: 380.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-49",
    x1: -7.2,
    y1: 372.9,
    x2: 38.8,
    y2: 372.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-50",
    x1: -14.5,
    y1: 365.59,
    x2: 31.5,
    y2: 365.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-51",
    x1: -7.2,
    y1: 358.28,
    x2: 38.8,
    y2: 358.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-52",
    x1: -14.5,
    y1: 350.97,
    x2: 31.5,
    y2: 350.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-53",
    x1: -7.2,
    y1: 343.65,
    x2: 38.8,
    y2: 343.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-54",
    x1: -14.5,
    y1: 336.34,
    x2: 31.5,
    y2: 336.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-55",
    x1: -7.2,
    y1: 329.03,
    x2: 38.8,
    y2: 329.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-56",
    x1: -14.5,
    y1: 321.72,
    x2: 31.5,
    y2: 321.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-57",
    x1: -7.2,
    y1: 314.41,
    x2: 38.8,
    y2: 314.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-58",
    x1: -14.5,
    y1: 307.1,
    x2: 31.5,
    y2: 307.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-59",
    x1: -7.2,
    y1: 299.78,
    x2: 38.8,
    y2: 299.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-60",
    x1: -14.5,
    y1: 292.47,
    x2: 31.5,
    y2: 292.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-61",
    x1: -7.2,
    y1: 285.16,
    x2: 38.8,
    y2: 285.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-62",
    x1: -14.5,
    y1: 277.85,
    x2: 31.5,
    y2: 277.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-63",
    x1: -7.2,
    y1: 270.54,
    x2: 38.8,
    y2: 270.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-64",
    x1: -14.5,
    y1: 263.23,
    x2: 31.5,
    y2: 263.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-65",
    x1: -7.2,
    y1: 255.91,
    x2: 38.8,
    y2: 255.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-66",
    x1: -14.5,
    y1: 248.6,
    x2: 31.5,
    y2: 248.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-67",
    x1: -7.2,
    y1: 241.29,
    x2: 38.8,
    y2: 241.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-68",
    x1: -14.5,
    y1: 233.98,
    x2: 31.5,
    y2: 233.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-69",
    x1: -7.2,
    y1: 226.67,
    x2: 38.8,
    y2: 226.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-70",
    x1: -14.5,
    y1: 219.35,
    x2: 31.5,
    y2: 219.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-71",
    x1: -7.2,
    y1: 212.04,
    x2: 38.8,
    y2: 212.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-72",
    x1: -14.5,
    y1: 204.73,
    x2: 31.5,
    y2: 204.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-73",
    x1: -7.2,
    y1: 197.42,
    x2: 38.8,
    y2: 197.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-74",
    x1: -14.5,
    y1: 190.11,
    x2: 31.5,
    y2: 190.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-75",
    x1: -7.2,
    y1: 182.8,
    x2: 38.8,
    y2: 182.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-76",
    x1: -14.5,
    y1: 175.48,
    x2: 31.5,
    y2: 175.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-77",
    x1: -7.2,
    y1: 168.17,
    x2: 38.8,
    y2: 168.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-78",
    x1: -14.5,
    y1: 160.86,
    x2: 31.5,
    y2: 160.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-79",
    x1: -7.2,
    y1: 153.55,
    x2: 38.8,
    y2: 153.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-80",
    x1: -14.5,
    y1: 146.24,
    x2: 31.5,
    y2: 146.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-81",
    x1: -7.2,
    y1: 138.92,
    x2: 38.8,
    y2: 138.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-82",
    x1: -14.5,
    y1: 131.61,
    x2: 31.5,
    y2: 131.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-83",
    x1: -7.2,
    y1: 124.3,
    x2: 38.8,
    y2: 124.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-84",
    x1: -14.5,
    y1: 116.99,
    x2: 31.5,
    y2: 116.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-85",
    x1: -7.2,
    y1: 109.68,
    x2: 38.8,
    y2: 109.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-86",
    x1: -14.5,
    y1: 102.37,
    x2: 31.5,
    y2: 102.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-87",
    x1: -7.2,
    y1: 95.05,
    x2: 38.8,
    y2: 95.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-88",
    x1: -14.5,
    y1: 87.74,
    x2: 31.5,
    y2: 87.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-89",
    x1: -7.2,
    y1: 80.43,
    x2: 38.8,
    y2: 80.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-90",
    x1: -14.5,
    y1: 73.12,
    x2: 31.5,
    y2: 73.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-91",
    x1: -7.2,
    y1: 65.81,
    x2: 38.8,
    y2: 65.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-92",
    x1: -14.5,
    y1: 58.49,
    x2: 31.5,
    y2: 58.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-93",
    x1: -7.2,
    y1: 51.18,
    x2: 38.8,
    y2: 51.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-94",
    x1: -14.5,
    y1: 43.87,
    x2: 31.5,
    y2: 43.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-95",
    x1: -7.2,
    y1: 36.56,
    x2: 38.8,
    y2: 36.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-96",
    x1: -14.5,
    y1: 29.25,
    x2: 31.5,
    y2: 29.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-97",
    x1: -7.2,
    y1: 21.94,
    x2: 38.8,
    y2: 21.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-98",
    x1: -14.5,
    y1: 14.62,
    x2: 31.5,
    y2: 14.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-99",
    x1: -7.2,
    y1: 7.31,
    x2: 38.8,
    y2: 7.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: -14.5,
    x2: 31.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: -36.45,
    y1: 709.25,
    x2: 9.55,
    y2: 709.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: -43.75,
    y1: 701.93,
    x2: 2.25,
    y2: 701.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: -36.45,
    y1: 694.62,
    x2: 9.55,
    y2: 694.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: -43.75,
    y1: 687.31,
    x2: 2.25,
    y2: 687.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: -36.45,
    y1: 680,
    x2: 9.55,
    y2: 680
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: -43.75,
    y1: 672.69,
    x2: 2.25,
    y2: 672.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: -36.45,
    y1: 665.37,
    x2: 9.55,
    y2: 665.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: -43.75,
    y1: 658.06,
    x2: 2.25,
    y2: 658.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: -36.45,
    y1: 650.75,
    x2: 9.55,
    y2: 650.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: -43.75,
    y1: 643.44,
    x2: 2.25,
    y2: 643.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: -36.45,
    y1: 636.13,
    x2: 9.55,
    y2: 636.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: -43.75,
    y1: 628.82,
    x2: 2.25,
    y2: 628.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: -36.45,
    y1: 621.5,
    x2: 9.55,
    y2: 621.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: -43.75,
    y1: 614.19,
    x2: 2.25,
    y2: 614.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: -36.45,
    y1: 606.88,
    x2: 9.55,
    y2: 606.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: -43.75,
    y1: 599.57,
    x2: 2.25,
    y2: 599.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: -36.45,
    y1: 592.26,
    x2: 9.55,
    y2: 592.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: -43.75,
    y1: 584.94,
    x2: 2.25,
    y2: 584.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: -36.45,
    y1: 577.63,
    x2: 9.55,
    y2: 577.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: -43.75,
    y1: 570.32,
    x2: 2.25,
    y2: 570.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: -36.45,
    y1: 563.01,
    x2: 9.55,
    y2: 563.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: -43.75,
    y1: 555.7,
    x2: 2.25,
    y2: 555.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-25",
    x1: -36.45,
    y1: 548.39,
    x2: 9.55,
    y2: 548.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: -43.75,
    y1: 541.07,
    x2: 2.25,
    y2: 541.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-27",
    x1: -36.45,
    y1: 533.76,
    x2: 9.55,
    y2: 533.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-28",
    x1: -43.75,
    y1: 526.45,
    x2: 2.25,
    y2: 526.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: -36.45,
    y1: 519.14,
    x2: 9.55,
    y2: 519.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-30",
    x1: -43.75,
    y1: 511.83,
    x2: 2.25,
    y2: 511.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-31",
    x1: -36.45,
    y1: 504.51,
    x2: 9.55,
    y2: 504.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-32",
    x1: -43.75,
    y1: 497.2,
    x2: 2.25,
    y2: 497.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-33",
    x1: -36.45,
    y1: 489.89,
    x2: 9.55,
    y2: 489.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-34",
    x1: -43.75,
    y1: 482.58,
    x2: 2.25,
    y2: 482.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-35",
    x1: -36.45,
    y1: 475.27,
    x2: 9.55,
    y2: 475.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-36",
    x1: -43.75,
    y1: 467.96,
    x2: 2.25,
    y2: 467.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-37",
    x1: -36.45,
    y1: 460.64,
    x2: 9.55,
    y2: 460.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-38",
    x1: -43.75,
    y1: 453.33,
    x2: 2.25,
    y2: 453.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-39",
    x1: -36.45,
    y1: 446.02,
    x2: 9.55,
    y2: 446.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-40",
    x1: -43.75,
    y1: 438.71,
    x2: 2.25,
    y2: 438.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-41",
    x1: -36.45,
    y1: 431.4,
    x2: 9.55,
    y2: 431.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-42",
    x1: -43.75,
    y1: 424.08,
    x2: 2.25,
    y2: 424.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-43",
    x1: -36.45,
    y1: 416.77,
    x2: 9.55,
    y2: 416.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-44",
    x1: -43.75,
    y1: 409.46,
    x2: 2.25,
    y2: 409.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-45",
    x1: -36.45,
    y1: 402.15,
    x2: 9.55,
    y2: 402.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-46",
    x1: -43.75,
    y1: 394.84,
    x2: 2.25,
    y2: 394.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-47",
    x1: -36.45,
    y1: 387.52,
    x2: 9.55,
    y2: 387.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-48",
    x1: -43.75,
    y1: 380.21,
    x2: 2.25,
    y2: 380.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-49",
    x1: -36.45,
    y1: 372.9,
    x2: 9.55,
    y2: 372.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-50",
    x1: -43.75,
    y1: 365.59,
    x2: 2.25,
    y2: 365.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-51",
    x1: -36.45,
    y1: 358.28,
    x2: 9.55,
    y2: 358.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-52",
    x1: -43.75,
    y1: 350.97,
    x2: 2.25,
    y2: 350.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-53",
    x1: -36.45,
    y1: 343.65,
    x2: 9.55,
    y2: 343.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-54",
    x1: -43.75,
    y1: 336.34,
    x2: 2.25,
    y2: 336.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-55",
    x1: -36.45,
    y1: 329.03,
    x2: 9.55,
    y2: 329.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-56",
    x1: -43.75,
    y1: 321.72,
    x2: 2.25,
    y2: 321.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-57",
    x1: -36.45,
    y1: 314.41,
    x2: 9.55,
    y2: 314.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-58",
    x1: -43.75,
    y1: 307.1,
    x2: 2.25,
    y2: 307.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-59",
    x1: -36.45,
    y1: 299.78,
    x2: 9.55,
    y2: 299.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-60",
    x1: -43.75,
    y1: 292.47,
    x2: 2.25,
    y2: 292.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-61",
    x1: -36.45,
    y1: 285.16,
    x2: 9.55,
    y2: 285.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-62",
    x1: -43.75,
    y1: 277.85,
    x2: 2.25,
    y2: 277.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-63",
    x1: -36.45,
    y1: 270.54,
    x2: 9.55,
    y2: 270.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-64",
    x1: -43.75,
    y1: 263.23,
    x2: 2.25,
    y2: 263.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-65",
    x1: -36.45,
    y1: 255.91,
    x2: 9.55,
    y2: 255.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-66",
    x1: -43.75,
    y1: 248.6,
    x2: 2.25,
    y2: 248.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-67",
    x1: -36.45,
    y1: 241.29,
    x2: 9.55,
    y2: 241.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-68",
    x1: -43.75,
    y1: 233.98,
    x2: 2.25,
    y2: 233.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-69",
    x1: -36.45,
    y1: 226.67,
    x2: 9.55,
    y2: 226.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-70",
    x1: -43.75,
    y1: 219.35,
    x2: 2.25,
    y2: 219.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-71",
    x1: -36.45,
    y1: 212.04,
    x2: 9.55,
    y2: 212.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-72",
    x1: -43.75,
    y1: 204.73,
    x2: 2.25,
    y2: 204.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-73",
    x1: -36.45,
    y1: 197.42,
    x2: 9.55,
    y2: 197.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-74",
    x1: -43.75,
    y1: 190.11,
    x2: 2.25,
    y2: 190.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-75",
    x1: -36.45,
    y1: 182.8,
    x2: 9.55,
    y2: 182.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-76",
    x1: -43.75,
    y1: 175.48,
    x2: 2.25,
    y2: 175.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-77",
    x1: -36.45,
    y1: 168.17,
    x2: 9.55,
    y2: 168.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-78",
    x1: -43.75,
    y1: 160.86,
    x2: 2.25,
    y2: 160.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-79",
    x1: -36.45,
    y1: 153.55,
    x2: 9.55,
    y2: 153.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-80",
    x1: -43.75,
    y1: 146.24,
    x2: 2.25,
    y2: 146.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-81",
    x1: -36.45,
    y1: 138.92,
    x2: 9.55,
    y2: 138.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-82",
    x1: -43.75,
    y1: 131.61,
    x2: 2.25,
    y2: 131.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-83",
    x1: -36.45,
    y1: 124.3,
    x2: 9.55,
    y2: 124.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-84",
    x1: -43.75,
    y1: 116.99,
    x2: 2.25,
    y2: 116.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-85",
    x1: -36.45,
    y1: 109.68,
    x2: 9.55,
    y2: 109.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-86",
    x1: -43.75,
    y1: 102.37,
    x2: 2.25,
    y2: 102.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-87",
    x1: -36.45,
    y1: 95.05,
    x2: 9.55,
    y2: 95.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-88",
    x1: -43.75,
    y1: 87.74,
    x2: 2.25,
    y2: 87.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-89",
    x1: -36.45,
    y1: 80.43,
    x2: 9.55,
    y2: 80.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-90",
    x1: -43.75,
    y1: 73.12,
    x2: 2.25,
    y2: 73.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-91",
    x1: -36.45,
    y1: 65.81,
    x2: 9.55,
    y2: 65.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-92",
    x1: -43.75,
    y1: 58.49,
    x2: 2.25,
    y2: 58.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-93",
    x1: -36.45,
    y1: 51.18,
    x2: 9.55,
    y2: 51.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-94",
    x1: -43.75,
    y1: 43.87,
    x2: 2.25,
    y2: 43.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-95",
    x1: -36.45,
    y1: 36.56,
    x2: 9.55,
    y2: 36.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-96",
    x1: -43.75,
    y1: 29.25,
    x2: 2.25,
    y2: 29.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-97",
    x1: -36.45,
    y1: 21.94,
    x2: 9.55,
    y2: 21.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-98",
    x1: -43.75,
    y1: 14.62,
    x2: 2.25,
    y2: 14.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-99",
    x1: -36.45,
    y1: 7.31,
    x2: 9.55,
    y2: 7.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: -43.75,
    x2: 2.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 139.05,
    y1: 0.51,
    x2: 185.05,
    y2: 0.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 109.8,
    y1: 0.51,
    x2: 155.8,
    y2: 0.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 80.55,
    y1: 0.51,
    x2: 126.55,
    y2: 0.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 51.3,
    y1: 0.51,
    x2: 97.3,
    y2: 0.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 22.05,
    y1: 0.51,
    x2: 68.05,
    y2: 0.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: -7.2,
    y1: 0.51,
    x2: 38.8,
    y2: 0.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: -36.45,
    y1: 0.51,
    x2: 9.55,
    y2: 0.51
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Sewti Ilak Logo all White") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M45.79,399.85H35.24a5.79,5.79,0,0,1-1.17-3.76q0-4.79,3.77-4.78A3.48,3.48,0,0,1,41.35,394l3.94-2.68a7.75,7.75,0,0,0-7.7-5c-5.28,0-9.05,4.19-9.05,9.46a9.73,9.73,0,0,0,.93,4.1H24.94v5.61H45.79Z",
    transform: "translate(0 -0.09)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M131.19,438h59.35c9.38,0,14.06-5,14.06-15.15V384h-9.37v35.66a18.21,18.21,0,0,1-.67,6c-.92,1.84-2.85,2.76-5.94,2.76H67.89c1.42-1.59,2.09-4.77,2.09-9.71V384H60.61v35.24c0,2.93-.34,5.11-1,6.37-.92,1.92-2.84,2.84-5.61,2.84H25.53c-5.11,0-9-.92-11.47-2.68-3.18-2.17-4.77-6-4.77-11.47V400H0v14.31Q0,438.06,26.62,438H131.19Z",
    transform: "translate(0 -0.09)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 213.23,
    y: 383.86,
    width: 9.29,
    height: 54.08
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M225.2,451.33h-6.78a3.38,3.38,0,0,1-1.51-3.18,3.09,3.09,0,0,1,2.85-3.26,2.14,2.14,0,0,1,2.34,1.84l3-1.42c-1.18-2.6-2.93-3.85-5.28-3.85a6.69,6.69,0,0,0-6.53,6.94,15.16,15.16,0,0,0,.76,2.93h-3.35v3.85H225.2Z",
    transform: "translate(0 -0.09)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 264.29,
    y: 461.04,
    width: 9.21,
    height: 9.29
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 280.12,
    y: 461.04,
    width: 9.21,
    height: 9.29
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M354.12,438h74.77c9.29,0,14-5,14-15.15V400h-9.37v19.67a18.21,18.21,0,0,1-.67,6c-.92,1.84-2.85,2.76-5.94,2.76h-109c-4.77,0-8-2.43-11.47-8.7-3.68-6.62-9.21-10-16.58-10h-3.68v8.54a9.56,9.56,0,0,1,1.51-.08c5.35,0,8.45,3.68,8.45,8.87,0,8.54-8.2,15.74-19.08,15.74-12.14,0-19.67-8.12-19.67-21.1V413.5H248v9.37a28.54,28.54,0,0,0,28.8,29.05c13.64,0,24.86-8.2,27.54-21.26,3.54,5.31,6.31,7.08,14.74,7.33v0h35.07Z",
    transform: "translate(0 -0.09)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 433.4,
    y: 382.94,
    width: 9.21,
    height: 9.29
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 417.58,
    y: 382.94,
    width: 9.21,
    height: 9.29
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M545.33,399.85c-9,0-18.25,5.61-25.53,15.66V404h-9.38V418.6c0,6.62-2.34,9.88-7.11,9.88H486.9v-9.71c0-11-7.2-18.83-17.41-18.83-10.64,0-18.76,7.53-18.76,18.58s8.21,19.5,18.34,19.5H478c-1.33,4.44-4.43,6.45-9.29,6.45v7.37q16.33,0,18.25-13.82h79.53c.25-3.09.42-5.94.42-8.7C566.93,409.73,559.73,399.85,545.33,399.85Zm-67.81,28.63h-8.29c-5,0-9-4.69-9-10.46,0-5.61,3.51-9.46,9-9.46,4.85,0,7.7,3.51,8.2,8.45Zm79.7,0H519.89c5.19-11.55,15.15-20.26,24.52-20.26,8,0,13,6.78,13,17.58Z",
    transform: "translate(0 -0.09)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M94,511.11c.77,0,1.49.05,2.2.11C97.79,511.19,97.07,511.15,94,511.11Z",
    transform: "translate(0 -0.09)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M96.16,511.22c-1.45,0-4.79,0-10.06,0H81.22c-4.37,0-8.23.43-10.78-2a6.35,6.35,0,0,1-1.89-4.66,6.07,6.07,0,0,1,2-4.59,7.88,7.88,0,0,1,4.58-1.82,37,37,0,0,1,6.05-.29c4.87.07,6.62.15,5.24.15,5.31,0,9,0,11.14.07a6.58,6.58,0,0,1,6.77,6.55,5,5,0,0,1-.07,1h4a4.58,4.58,0,0,0,.07-.94,9.85,9.85,0,0,0-3-7.21,10,10,0,0,0-7.21-3.13c-4.88-.08-8.37-.15-10.41-.15h-.15c-3.56,0-7.79.07-12.66.15a10,10,0,0,0-7.21,3.13,9.76,9.76,0,0,0-2.92,7.21,9.25,9.25,0,0,0,3.14,7.13,12.55,12.55,0,0,0,7.28,3.2H97.24c5.75,0,8.66,2.84,8.66,8.6a8.17,8.17,0,0,1-2.26,5.89,9.09,9.09,0,0,1-5.31,2.48,38.34,38.34,0,0,1-7,.36c-5.9-.14-7.94-.22-6.12-.22-4.15,0-7.35,0-9.61-.07a8.12,8.12,0,0,1-7.93-7.5H64a12.69,12.69,0,0,0,2.48,6.77,10.9,10.9,0,0,0,8,4.45c4,.21,7.57.36,10.85.36h.14c5.24,0,9.83-.15,13.69-.36a10.51,10.51,0,0,0,7.65-4,13.06,13.06,0,0,0,1-15C105.66,513.57,101.75,511.66,96.16,511.22Z",
    transform: "translate(0 -0.09)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M158,498.88a10.32,10.32,0,0,0-7.35-3.57c-4.15-.29-8.81-.44-13.84-.44-2.91,0-6.55.15-10.84.44a10.28,10.28,0,0,0-7.36,3.64,13.48,13.48,0,0,0-3.2,7.65c-.07.43-.07,3.42-.07,8.95v.66l.07,19.73h3.71V522.83h38.23v13.11h3.78c.07-2.11.15-9,.15-20.39v-.14c0-5-.08-8-.15-8.89A13.43,13.43,0,0,0,158,498.88Zm-.65,20.17H119.15V507.11a8.16,8.16,0,0,1,7.94-8.23c2.47-.07,5.53-.07,9.1-.07h.58c6,0,10.27,0,12.67.07a8.16,8.16,0,0,1,7.94,8.23Z",
    transform: "translate(0 -0.09)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-100",
    points: "216.42 531.34 202.08 494.86 198.22 494.86 183.88 531.34 167.35 494.86 163.49 494.86 181.99 535.85 185.92 535.85 200.19 499.74 214.38 535.78 218.32 535.85 236.81 494.86 232.95 494.86 216.42 531.34"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-100",
    points: "242.63 498.21 263.53 498.21 263.53 535.85 267.02 535.85 267.02 498.21 287.41 498.21 287.41 494.71 242.63 494.71 242.63 498.21"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M293.74,515.77c0,11.5,0,18.2.07,20.17h3.72V495h-3.79Z",
    transform: "translate(0 -0.09)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M339.32,515.77c0,11.5,0,18.2.07,20.17h3.71V495h-3.78Z",
    transform: "translate(0 -0.09)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M354,494.66h-3.49v41.06h.07v.22l21.62.07c11.87.07,19.08,0,21.48-.07v-4H354Z",
    transform: "translate(0 -0.09)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M444.3,498.88a10.3,10.3,0,0,0-7.35-3.57c-4.15-.29-8.81-.44-13.83-.44-2.92,0-6.56.15-10.85.44a10.24,10.24,0,0,0-7.35,3.64,13.56,13.56,0,0,0-3.21,7.65c-.07.43-.07,3.42-.07,8.95v.66l.07,19.73h3.71V522.83h38.23v13.11h3.78c.08-2.11.15-9,.15-20.39v-.14c0-5-.07-8-.15-8.89A13.43,13.43,0,0,0,444.3,498.88Zm-.65,20.17H405.42V507.11a8.16,8.16,0,0,1,7.94-8.23c2.48-.07,5.53-.07,9.1-.07H423c6,0,10.27,0,12.67.07a8.16,8.16,0,0,1,7.94,8.23Z",
    transform: "translate(0 -0.09)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-100",
    points: "493.96 495.01 488.43 495.01 456.24 520.93 456.24 495.01 452.75 495.01 452.75 536 456.24 536 456.24 525.37 472.12 512.55 490.97 536 495.49 536 474.81 510.37 493.96 495.01"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M290.23,163.59v151a90.17,90.17,0,0,0,84.1-89.93v-61Z",
    transform: "translate(0 -0.09)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M278,163.58l-84.1,0v61.08A90.17,90.17,0,0,0,278,314.57Z",
    transform: "translate(0 -0.09)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M278,151.33v-61a6.14,6.14,0,0,1,12.27,0v61l84.1,0v-61a90.24,90.24,0,0,0-180.47,0v61Z",
    transform: "translate(0 -0.09)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M284.09,349.62A126.22,126.22,0,0,1,158,223.55a10.82,10.82,0,1,1,21.64,0,104.44,104.44,0,0,0,208.87,0,10.82,10.82,0,1,1,21.64,0A126.22,126.22,0,0,1,284.09,349.62Z",
    transform: "translate(0 -0.09)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWithText);
export default __webpack_public_path__ + "static/media/logoWithText.e1b71608af85c668840affd3abdeb962.svg";
export { ForwardRef as ReactComponent };